module.exports = __webpack_public_path__ + "54344e3ebb04cc525e559928c4fa2b68.png";